var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6053_19749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9601 14H9.03986C8.76407 14 8.49958 13.8946 8.30457 13.7071C8.10956 13.5196 8 13.2652 8 13C8 12.7348 8.10956 12.4804 8.30457 12.2929C8.49958 12.1054 8.76407 12 9.03986 12H30.9601C31.2359 12 31.5004 12.1054 31.6954 12.2929C31.8904 12.4804 32 12.7348 32 13C32 13.2652 31.8904 13.5196 31.6954 13.7071C31.5004 13.8946 31.2359 14 30.9601 14Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7269 21H9.27307C8.93543 21 8.61162 20.8946 8.37288 20.7071C8.13413 20.5196 8 20.2652 8 20C8 19.7348 8.13413 19.4804 8.37288 19.2929C8.61162 19.1054 8.93543 19 9.27307 19H26.7269C27.0646 19 27.3884 19.1054 27.6271 19.2929C27.8659 19.4804 28 19.7348 28 20C28 20.2652 27.8659 20.5196 27.6271 20.7071C27.3884 20.8946 27.0646 21 26.7269 21Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9418 28L9.05817 28C8.77753 28 8.50838 27.8946 8.30993 27.7071C8.11149 27.5196 8 27.2652 8 27C8 26.7348 8.11149 26.4804 8.30993 26.2929C8.50838 26.1054 8.77753 26 9.05817 26L20.9418 26C21.2225 26 21.4916 26.1054 21.6901 26.2929C21.8885 26.4804 22 26.7348 22 27C22 27.2652 21.8885 27.5196 21.6901 27.7071C21.4916 27.8946 21.2225 28 20.9418 28Z",
    fill: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6053_19749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.0a2974143c50723dc7a216b47cc4fe89.svg";
export { ForwardRef as ReactComponent };